/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_QUERY = "DO_QUERY";
export const DO_QUERY_SUCCESS = "DO_QUERY_SUCCESS";
export const DO_QUERY_ERROR = "DO_QUERY_ERROR";
export const DO_FORZAR_DNE = "DO_FORZAR_DNE";
export const DO_LANDING = "DO_LANDING";
export const DO_PASO_CARRO_ABANDONADO = "DO_PASO_CARRO_ABANDONADO";
export const DO_PASO_CARRO_ABANDONADO_SUCCESS =
  "DO_PASO_CARRO_ABANDONADO_SUCCESS";
export const DO_PASO_CARRO_ABANDONADO_ERROR = "DO_PASO_CARRO_ABANDONADO_ERROR";
export const DO_PASO1 = "DO_PASO1";
export const DO_PASO1_SUCCESS = "DO_PASO1_SUCCESS";
export const DO_PASO1_ERROR = "DO_PASO1_ERROR";
export const DO_SEARCH_ENCOTESA = "DO_SEARCH_ENCOTESA";
export const DO_SEARCH_ENCOTESA_SUCCESS = "DO_SEARCH_ENCOTESA_SUCCESS";
export const DO_SEARCH_ENCOTESA_ERROR = "DO_SEARCH_ENCOTESA_ERROR";
export const DO_PASO2 = "DO_PASO2";
export const DO_PASO3 = "DO_PASO3";
export const DO_PASO4 = "DO_PASO4";
export const DO_PASO4_SUCCESS = "DO_PASO4_SUCCESS";
export const DO_PASO4_ERROR = "DO_PASO4_ERROR";
export const DO_SUCURSAL = "DO_SUCURSAL";
export const DO_SUCURSAL_ERROR = "DO_SUCURSAL_ERROR";
export const DO_CONFIRMAR_DATA_SUCURSAL = "DO_CONFIRMAR_DATA_SUCURSAL";
export const DO_GRACIAS_CA = "DO_GRACIAS_CA";
export const DO_SOLICITAR_TURNO = "DO_SOLICITAR_TURNO";
export const DO_SOCIAL_NET = "DO_SOCIAL_NET";
export const DO_SOCIAL_NET_SUCCESS = "DO_SOCIAL_NET_SUCCESS";
export const DO_SOCIAL_NET_ERROR = "DO_SOCIAL_NET_ERROR";
export const DO_CONFIRMAR_DATA = "DO_CONFIRMAR_DATA";
export const DO_CONFIRMAR_DATA_NOCLIENTE = "DO_CONFIRMAR_DATA_NOCLIENTE";
export const DO_GRACIAS_NOCLIENTE = "DO_GRACIAS_NOCLIENTE";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_CLICK_TRACKING = "DO_CLICK_TRACKING";
export const DO_INGRESO_BANCA_ONLINE = "DO_INGRESO_BANCA_ONLINE";
export const DO_MOCK = "DO_MOCK";
export const DO_OPEN_MODAL = "DO_OPEN_MODAL";
export const SET_ADOBE_TARGET_EXPERIENCE = "SET_ADOBE_TARGET_EXPERIENCE";
export const DO_NOTIFICATION_TOAST = "DO_NOTIFICATION_TOAST";
export const DO_NOTIFICATION_TOAST_RESET = "DO_NOTIFICATION_TOAST_RESET";
export const DO_CONSULTA_ESCLIENTE = "DO_CONSULTA_ESCLIENTE";
export const DO_CONSULTA_ESCLIENTE_SUCCESS = "DO_CONSULTA_ESCLIENTE_SUCCESS";
export const DO_CONSULTA_ESCLIENTE_ERROR = "DO_CONSULTA_ESCLIENTE_ERROR";
export const DO_CONSULTAR_RENAPER = "DO_CONSULTAR_RENAPER";
export const DO_CONSULTAR_RENAPER_SUCCESS = "DO_CONSULTAR_RENAPER_SUCCESS";
export const DO_CONSULTAR_RENAPER_ERROR = "DO_CONSULTAR_RENAPER_ERROR";
export const DO_SELECT_PARTICULAR = "DO_SELECT_PARTICULAR";
export const DO_SELECT_ALTERNATIVO = "DO_SELECT_ALTERNATIVO";
export const doSelectEncotesaParticular = "doSelectEncotesaParticular";
export const doSelectEncotesaAlternativo = "doSelectEncotesaAlternativo";
export const DO_NORMALIZAR_DOMICILIO = "DO_NORMALIZAR_DOMICILIO";
export const DO_NORMALIZAR_DOMICILIO_SUCCESS =
  "DO_NORMALIZAR_DOMICILIO_SUCCESS";
export const DO_NORMALIZAR_DOMICILIO_ERROR = "DO_NORMALIZAR_DOMICILIO_ERROR";
export const doTCode = "doTCode";
export const DO_CONSULTA = "DO_CONSULTA";
export const DO_CONSULTA_SUCCESS = "DO_CONSULTA_SUCCESS";
export const DO_CONSULTA_ERROR = "DO_CONSULTA_ERROR";
export const DO_ENVIO_SMS = "DO_ENVIO_SMS";
export const DO_ENVIO_SMS_SUCCESS = "DO_ENVIO_SMS_SUCCESS";
export const DO_ENVIO_SMS_ERROR = "DO_ENVIO_SMS_ERROR";
export const DO_GET_TOKEN_USER_ID = "DO_GET_TOKEN_USER_ID";
export const DO_TOKENIZAR_USER_SUCCESS = "DO_TOKENIZAR_USER_SUCCESS";
export const DO_TOKENIZAR_USER_ERROR = "DO_TOKENIZAR_USER_ERROR";
export const DO_GET_DEVICEID = "DO_GET_DEVICEID";
export const DO_GET_DEVICEIDTIMESTAMP = "DO_GET_DEVICEIDTIMESTAMP";
export const DO_CONSULTAR_DOMICILIO = "DO_CONSULTAR_DOMICILIO";
export const DO_CONSULTAR_DOMICILIO_SUCCESS = "DO_CONSULTAR_DOMICILIO_SUCCESS";
export const DO_CONSULTAR_DOMICILIO_ERROR = "DO_CONSULTAR_DOMICILIO_ERROR";
export const DO_VALIDAR_DOMICILIO = "DO_VALIDAR_DOMICILIO";
export const DO_VALIDAR_DOMICILIO_SUCCESS = "DO_VALIDAR_DOMICILIO_SUCCESS";
export const DO_VALIDAR_DOMICILIO_ERROR = "DO_VALIDAR_DOMICILIO_ERROR";
export const DO_GRABAR_DOMICILIO = "DO_GRABAR_DOMICILIO";
export const DO_GRABAR_DOMICILIO_SUCCESS = "DO_GRABAR_DOMICILIO_SUCCESS";
export const DO_GRABAR_DOMICILIO_ERROR = "DO_GRABAR_DOMICILIO_ERROR";
export const DO_PROCESAR_DOMICILIO = "DO_PROCESAR_DOMICILIO";
export const DO_PROCESAR_DOMICILIO_SUCCESS = "DO_PROCESAR_DOMICILIO_SUCCESS";
export const DO_PROCESAR_DOMICILIO_ERROR = "DO_PROCESAR_DOMICILIO_ERROR";
export const DO_FETCH_SUCURSALES = "DO_FETCH_SUCURSALES";
export const DO_DATOS_PERSONALES = "DO_DATOS_PERSONALES";
export const DO_DATOS_LABORALES = "DO_DATOS_LABORALES";
export const DO_INFORMACION_ADICIONAL = "DO_INFORMACION_ADICIONAL";
export const DO_CLICK_CTA = "DO_CLICK_CTA";
export const DO_VERIDAS_EVENT = "DO_VERIDAS_EVENT";
export const DO_DIGITAL = "DO_DIGITAL";
export const DO_DATA_AUTH_ASO = "DO_DATA_AUTH_ASO";
export const DO_ENVIAR_EVENTO_DVS_FS = "DO_ENVIAR_EVENTO_DVS_FS";
export const GET_REINTENTOS_BIO = "GET_REINTENTOS_BIO";
export const DO_PRESENCIAL = "DO_PRESENCIAL";
export const GET_VERIDAS_IFRAME = "GET_VERIDAS_IFRAME";
export const GET_VERIDAS_RESULT = "GET_VERIDAS_RESULT";
export const GET_RENAPER_VALIDATION = "GET_RENAPER_VALIDATION";
export const DO_ENVIAR_RESULTADOS_BIOMETRIA = "DO_ENVIAR_RESULTADOS_BIOMETRIA";
export const DO_SAVE_IFRAME = "DO_SAVE_IFRAME";
export const DO_PRELOAD_SDK = "DO_PRELOAD_SDK";
export const DO_IS_VISIBLE_SDK = "DO_IS_VISIBLE_SDK";
export const DO_POST_VERIDAS_LOGIN = "DO_POST_VERIDAS_LOGIN";
export const DO_POST_FRONT_DNI = "DO_POST_FRONT_DNI";
export const DO_POST_REVERSE_DNI = "DO_POST_REVERSE_DNI";
export const DO_POST_SELFIES = "DO_POST_SELFIES";
export const DO_GET_RESULT = "DO_GET_RESULT";
export const DO_POST_SELFIE = "DO_POST_SELFIE";
export const DO_POST_SELFIE_ALIVE = "DO_POST_SELFIE_ALIVE";
export const DO_POST_SUCCESS = "DO_POST_SUCCESS";
export const DO_POST_ERROR = "DO_POST_ERROR";
export const DO_ENVIO_FRENTE_DNI_SUCCESS = "DO_ENVIO_FRENTE_DNI_SUCCESS";
export const DO_CONFIGURACION = "DO_CONFIGURACION";
export const DO_CONTRATACION = "DO_CONTRATACION";
export const DO_HUELLA_AVANZADA = "DO_HUELLA_AVANZADA";
export const DO_CONFIRMACION_SUCCESS = "DO_CONFIRMACION_SUCCESS";
export const DO_CONFIRMACION_ERROR = "DO_CONFIRMACION_ERROR";
export const DO_SEARCH_CONTRACT = "DO_SEARCH_CONTRACT";
export const DO_SEARCH_CONTRACT_SUCCESS = "DO_SEARCH_CONTRACT_SUCCESS";
export const DO_SEARCH_CONTRACT_ERROR = "DO_SEARCH_CONTRACT_ERROR";
export const DO_CONTRATO_PENDING_SIGNATURE = "DO_CONTRATO_PENDING_SIGNATURE";
export const DO_CONTRATO = "DO_CONTRATO";
export const DO_CONTRATO_SUCCESS = "DO_CONTRATO_SUCCESS";
export const DO_CONTRATO_ERROR = "DO_CONTRATO_ERROR";
export const DO_CONSULTA_CUENTA_CLIENTE_SUCCESS =
  "DO_CONSULTA_CUENTA_CLIENTE_SUCCESS";
export const DO_NORMALIZAR_NUMERO = "DO_NORMALIZAR_NUMERO";
export const DO_NORMALIZAR_NUMERO_SUCCESS = "DO_NORMALIZAR_NUMERO_SUCCESS";
export const DO_NORMALIZAR_NUMERO_ERROR = "DO_NORMALIZAR_NUMERO_ERROR";
export const DO_NORMALIZAR_CELULAR = "DO_NORMALIZAR_CELULAR";
export const DO_CELULAR = "DO_CELULAR";
export const DO_CELULAR_SUCCESS = "DO_CELULAR_SUCCESS";
export const DO_CELULAR_ERROR = "DO_CELULAR_ERROR";
export const DO_ENVIO_CELULAR = "DO_ENVIO_CELULAR";
export const DO_ENVIO_CELULAR_SUCCESS = "DO_ENVIO_CELULAR_SUCCESS";
export const DO_ENVIO_CELULAR_ERROR = "DO_ENVIO_CELULAR_ERROR";
export const DO_USUARIO_CLAVE = "DO_USUARIO_CLAVE";
export const DO_USUARIO_CLAVE_SUCCESS = "DO_USUARIO_CLAVE_SUCCESS";
export const DO_USUARIO_CLAVE_ERROR = "DO_USUARIO_CLAVE_ERROR";
export const DO_INTERNAL_LINK = "DO_INTERNAL_LINK";
export const DO_VALIDAR_RIESGO = "DO_VALIDAR_RIESGO";
